import React, {useState} from 'react';
import {useWeb3React} from '@web3-react/core';
import styled from 'styled-components';
import Button from '../../Button';
import {ButtonAppearanceEnum} from '../../Button/types';
import useModal from '../../../hooks/useModal';
import ConnectModal from '../../ConnectModal';
import useAuth from '../../../hooks/useAuth';
import truncate from '../../../utils/truncate';

const Account = styled.div`
  background-color: #DCE5FF;
  display: flex;
  align-items: center;
  height: 36px;
  width: 160px;
  font-size: 12px;
  font-weight: 700;
  border-radius: 10px;
  justify-content: center;
  color: #252525;
  user-select: none;

  :hover {
    opacity: ${({theme}) => theme.opacity};
    cursor: pointer;
  }
`;

const DisconnectWrapper = styled.div`
  display: flex;
  align-items: end;
  justify-content: end;
  flex-direction: row;
  width: 200px;
`;

const Address = styled.span`
  padding: 0 !important;
`;


const WalletButton = () => {
    const {openModal} = useModal();
    const {account} = useWeb3React();
    const {login, logout} = useAuth();
    const [showDisconnect, setShowDisconnect] = useState(false);
    const logoutFunction = () => {
        logout();
        setShowDisconnect(!showDisconnect);
    };

    return (
        account ? (
            <DisconnectWrapper>
                <Account onClick={() => setShowDisconnect(!showDisconnect)}>
                    <Address>{truncate(account)}</Address>
                </Account>
                {showDisconnect &&
                <Button style={{background: "red", width: 36, marginLeft: 5}} onClick={logoutFunction}>
                    x
                </Button>
                }
            </DisconnectWrapper>
        ) : (
            <Button
                onClick={() =>
                    openModal({
                        children: ConnectModal,
                        props: {login},
                    })
                }
                appearance={ButtonAppearanceEnum.primary}
                style={{fontWeight: 600, width: 160}}
            >
                <p> Connect Wallet </p>
            </Button>
        ));
};

export default WalletButton;
